module.exports = __webpack_public_path__ + "img/root100.b2254235.png";